// @flow
import React, { useState } from 'react';

type Props = {
  onMoveItem: (toIndex: number) => void
}

// Keycode for 'Enter' key
const ENTER = 13;

const MoveToPosition = ({ onMoveItem }: Props) => {
  const [text, setText] = useState('');

  const onChangeText = (event) => {
    setText(event.target.value);
  };

  const handleMove = () => {
    // Parse, convert 1-index to 0-index
    const toIndex = parseInt(text, 10) - 1;

    onMoveItem(toIndex);

    setText('');
  }

  const onKeyDown = (event) => {
    if (event.keyCode === ENTER) {
      handleMove();
    }
  };

  return (
    <>
      <i className="material-icons">arrow_forward</i>
      <span onClick={handleMove}>Move to #</span>
      <input
        type="text"
        value={text}
        style={{ width: '20px' }}
        onChange={onChangeText}
        onKeyDown={onKeyDown}
      />
    </>
  );
};

export default MoveToPosition;
